const TermsAndCondition = () => {
    
    return (
        <div className=" flex items-center justify-center px-4 md:px-8 lg:px-16 xl:px-28 py-10">
            <div className=" bg-white w-full rounded-2xl shadow-2xl  p-3">
                {/* Header */}
                <div className="flex items-center justify-between bg-gradient-to-r from-[#ECF1FF] to-[#EED8FF] px-5 py-3 rounded-t-lg">
                    <h2 className="font-semibold text-lg sm:text-xl text-[#2C25C4]">
                        Terms & Conditions
                    </h2>
                    {/* <button
                        onClick={onClose}
                        className="rounded-full p-1 bg-[#FFFFFF] text-red-500 cursor-pointer"
                    >
                        <X size={20} />
                    </button> */}
                </div>

                {/* Content */}
                <div className="p-5  text-gray-800">
                    {/* Section 1 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">1. Acceptance of Terms</h3>
                    <p className="text-sm leading-relaxed">
                        By registering or using CareerConnect AI (for employers or job seekers),
                        you agree to comply with these Terms and Conditions and our Privacy Policy.
                        If you do not agree, please refrain from using our platform.
                    </p>

                    {/* Section 2 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">2. Eligibility</h3>
                    <p className="text-sm leading-relaxed">
                        <strong>Job Seekers:</strong> Must be at least 18 years old and provide accurate
                        personal, educational, and professional information. <br />
                        <strong>Employers/Recruiters:</strong> Must be legally authorized to hire employees
                        and ensure all job postings are truthful and lawful.
                    </p>

                    {/* Section 3 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">3. User Responsibilities</h3>
                    <ul className="list-disc pl-5 text-sm leading-relaxed space-y-1">
                        <li>Provide accurate, complete, and up-to-date information.</li>
                        <li>Do not share false, misleading, or fraudulent content.</li>
                        <li>Do not misuse or attempt to hack the platform.</li>
                        <li>Respect other users and maintain professional behavior.</li>
                    </ul>

                    {/* Section 4 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">4. Job Postings & Applications</h3>
                    <p className="text-sm leading-relaxed">
                        Employers are responsible for the accuracy of job descriptions. CareerConnect AI
                        is not liable for hiring decisions, offers, or employment outcomes. Job seekers
                        must apply with truthful information (resume, profile, etc.).
                    </p>

                    {/* Section 5 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">5. Prohibited Activities</h3>
                    <ul className="list-disc pl-5 text-sm leading-relaxed space-y-1">
                        <li>Posting fake jobs or resumes.</li>
                        <li>Using the platform for spam, scams, or fraudulent activity.</li>
                        <li>Sharing obscene, offensive, or illegal content.</li>
                        <li>Violating any applicable law or regulation.</li>
                    </ul>

                    {/* Section 6 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">6. Intellectual Property</h3>
                    <p className="text-sm leading-relaxed">
                        All content, design, logos, and features of CareerConnect AI are owned by us.
                        Users may not copy, reproduce, or distribute without written consent.
                    </p>

                    {/* Section 7 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">7. Privacy</h3>
                    <p className="text-sm leading-relaxed">
                        We respect your privacy. Data collected will be used as per our Privacy Policy.
                        By using the platform, you consent to such use.
                    </p>

                    {/* Section 8 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">8. Limitation of Liability</h3>
                    <p className="text-sm leading-relaxed">
                        CareerConnect AI is a connection platform. We are not responsible for guaranteeing
                        job placement, employer conduct, or accuracy of user-provided information. Users
                        use the platform at their own discretion.
                    </p>

                    {/* Section 9 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">9. Termination of Account</h3>
                    <p className="text-sm leading-relaxed">
                        We reserve the right to suspend or terminate accounts if false or fraudulent
                        information is detected, misuse or harmful activity occurs, or if any violation
                        of these Terms happens.
                    </p>

                    {/* Section 10 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">10. Changes to Terms</h3>
                    <p className="text-sm leading-relaxed">
                        We may update these Terms & Conditions at any time. Continued use of the platform
                        means acceptance of the revised terms.
                    </p>

                    {/* Section 11 */}
                    <h3 className="font-semibold text-primary-300 mt-4 mb-2">11. Governing Law</h3>
                    <p className="text-sm leading-relaxed mb-6">
                        These Terms & Conditions will be governed by and interpreted under the laws of
                        the Government of India.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsAndCondition;
